import {Component, Inject, OnInit, VERSION, ViewChild} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import {ConfirmDialogComponent} from "../../../confirm-dialog/confirm-dialog.component";
import {LanguagePipe} from "../../../../pipe/language.pipe";
import {UserService} from "../../../../service-data/user.service";
import {Product} from "../../../../../model/Product";
import {FacilityInventoryProduct} from "../../../../../model/FacilityInventoryProduct";
import {FacilityInventoryProductService} from "../../../../service-data/facility-inventory-product.service";
import {Organization} from "../../../../../model/Organization";
import {OrganizationService} from "../../../../service-data/organization.service";
import {ProductService} from "../../../../service-data/product.service";
import {MatTableDataSource} from "@angular/material/table";
import {FacilityInventoryProductEvent} from "../../../../../model/FacilityInventoryProductEvent";
import {FacilityInventoryProductEventService} from "../../../../service-data/facility-inventory-product-event.service";
import {PrintNodeOrder} from "../../../../../model/PrintNodeOrder";
import {PrintNodeOrderItem} from "../../../../../model/PrintNodeOrderItem";
import {PrintNodeOrderService} from "../../../../service-data/print-node-order.service";
import {PrintNodeOrderItemService} from "../../../../service-data/print-node-order-item.service";

@Component({
  selector: 'app-edit-facility-inventory-product-event',
  templateUrl: './edit-facility-inventory-product-event.component.html',
  styleUrls: ['./edit-facility-inventory-product-event.component.css']
})
export class EditFacilityInventoryProductEventComponent implements OnInit {
  public facilityInventoryProductEvent: FacilityInventoryProductEvent;
  public breakpoint: number; // Breakpoint observer code
  public actionType: string = ``;
  public date: Date = new Date();
  public quantity: number = 0;
  public formGroup: FormGroup;
  wasFormChanged = false;

  constructor(private formBuilder: FormBuilder, public dialog: MatDialog, public facilityInventoryProductEventService: FacilityInventoryProductEventService, @Inject(MAT_DIALOG_DATA) data, private dialogRef: MatDialogRef<EditFacilityInventoryProductEventComponent>) {
    this.facilityInventoryProductEvent = data.facilityInventoryProductEvent;
    this.quantity = this.facilityInventoryProductEvent.quantity;
    if ( this.facilityInventoryProductEvent.timestamp ) {
      this.date = new Date(this.facilityInventoryProductEvent.timestamp);
    } else {
      this.date = new Date();
    }
  }

  public ngOnInit(): void {
    this.formGroup = this.formBuilder.group({
      quantity: [this.quantity, [Validators.required]],
      date: [this.date, [Validators.required]],
    });

    this.breakpoint = window.innerWidth <= 600 ? 1 : 2; // Breakpoint observer code
  }

  public onSave(): void {
    this.facilityInventoryProductEvent.quantity = this.formGroup.controls.quantity.value;
    this.facilityInventoryProductEvent.timestamp = new Date(this.formGroup.controls.date.value + 'T12:00:00');
    this.facilityInventoryProductEventService.updateFacilityInventoryProductEvent(this.facilityInventoryProductEvent).subscribe( object => {
      console.log(`Updated FacilityInventoryProductEvent : ${object.ID}`);
    });
    this.markAsDirty(this.formGroup);
    this.dialogRef.close();
  }

  // tslint:disable-next-line:no-any
  public onResize(event: any): void {
    this.breakpoint = event.target.innerWidth <= 600 ? 1 : 2;
  }

  private markAsDirty(group: FormGroup): void {
    group.markAsDirty();
    // tslint:disable-next-line:forin
    for (const i in group.controls) {
      group.controls[i].markAsDirty();
    }
  }

  formChanged() {
    this.wasFormChanged = true;
  }

}
